import IconButton from '@/global/components/Button/IconButton'
import { MoonIcon, SunIcon } from 'lucide-react'
import React from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const ToggleTheme: React.FC = () => {
    const mode = useThemeStore(state => state.theme)
    const toggleTheme = useThemeStore(state => state.toggle)

    if (mode === 'dark') {
        document.documentElement.classList.remove('light')
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
    }

    return (
        <IconButton
            size="small"
            color="inherit"
            onClick={toggleTheme}
            title="Alternar tema"
            className="ml-1"
        >
            {mode === 'dark' ? (
                <SunIcon className="text-warning size-6" />
            ) : (
                <MoonIcon className="text-card/80 size-6" />
            )}
        </IconButton>
    )
}

export const useThemeStore = create(
    persist<{ theme: 'dark' | 'light'; toggle: () => void }>(
        (set, get) => ({
            theme: 'light',
            toggle: () =>
                set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
        }),
        {
            name: 'theme',
        },
    ),
)
